var w = Object.defineProperty;
var f = Object.getOwnPropertySymbols;
var D = Object.prototype.hasOwnProperty, H = Object.prototype.propertyIsEnumerable;
var p = (a, e, t) => e in a ? w(a, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : a[e] = t, d = (a, e) => {
  for (var t in e || (e = {}))
    D.call(e, t) && p(a, t, e[t]);
  if (f)
    for (var t of f(e))
      H.call(e, t) && p(a, t, e[t]);
  return a;
};
import { defineComponent as l, h as O, ref as y, watch as F, provide as b, onMounted as V, isVue2 as x } from "vue-demi";
import { ref as o, inject as v, watch as k } from "vue";
import { createInstance as E } from "@hackler/javascript-sdk";
const A = l({
  name: "HackleExperiment",
  props: {
    experimentKey: {
      type: Number,
      required: !0
    }
  },
  setup(a, { slots: e }) {
    const t = h(a.experimentKey), r = (n) => {
      var i, u;
      return (u = x ? (i = n.componentOptions) == null ? void 0 : i.propsData : n.props) != null ? u : {};
    };
    return () => {
      var n;
      return (n = e.default) == null ? void 0 : n.call(e, { loading: t.loading.value }).filter((i) => r(i).variation === t.variation.value);
    };
  }
}), N = l({
  name: "HackleVariation",
  props: {
    variation: {
      type: String,
      default: "A"
    }
  },
  setup(a, { slots: e }) {
    return () => {
      var t;
      return O("div", (t = e.default) == null ? void 0 : t.call(e));
    };
  }
}), s = Symbol("HackleSymbol"), P = l({
  name: "HackleProvider",
  props: {
    instance: {
      type: Object,
      required: !0
    },
    user: {
      type: Object,
      default: null
    }
  },
  setup(a, { slots: e }) {
    const t = y(a.instance), r = y(!!a.instance);
    return F(
      () => a.user,
      () => {
        var n, i, u, c;
        try {
          if (!(a.user && a.user.userId !== -1)) {
            t.value.resetUser();
            return;
          }
          const S = d(d({}, (i = (n = t.value).getUser) == null ? void 0 : i.call(n)), a.user);
          (c = (u = t.value).setUser) == null || c.call(u, S);
        } catch (m) {
          console.error("HackleProvider user watch error : ", m);
        }
      },
      { immediate: !0 }
    ), b(s, { instance: t, initialized: r }), V(() => {
      t.value && (window.hackleClient = t.value);
    }), () => {
      var n;
      return (n = e.default) == null ? void 0 : n.call(e);
    };
  }
}), R = l({
  name: "HackleFeature",
  props: {
    flagKey: {
      type: Number,
      required: !0
    }
  },
  setup(a, { slots: e }) {
    const t = g(a.flagKey);
    return () => {
      var r;
      return t.isOn.value ? (r = e.default) == null ? void 0 : r.call(e) : null;
    };
  }
}), h = (a) => {
  const e = o("A"), t = o("SDK_NOT_READY"), r = o(!0), n = v(s), i = k(
    n.initialized,
    (u) => {
      u && n.instance.value.onReady(() => {
        const c = n.instance.value.variationDetail(a);
        e.value = c.variation, t.value = c.reason, r.value = !1, i();
      });
    },
    { immediate: !0 }
  );
  return {
    variation: e,
    reason: t,
    loading: r
  };
}, j = (a) => h(a).variation, q = () => {
  const a = v(s);
  if (!a)
    throw new Error("핵클 인스턴스가 초기화되지 않았습니다.");
  return a.instance;
}, g = (a) => {
  const e = o(!1), t = o("SDK_NOT_READY"), r = o(!0), n = v(s), i = k(
    n.initialized,
    (u) => {
      u && n.instance.value.onReady(() => {
        const c = n.instance.value.featureFlagDetail(a);
        e.value = c.isOn, t.value = c.reason, r.value = !1, i();
      });
    },
    { immediate: !0 }
  );
  return {
    isOn: e,
    reason: t,
    loading: r
  };
}, z = (a) => g(a).isOn;
function C(a, e) {
  return E(a, e);
}
export {
  A as HackleExperiment,
  R as HackleFeature,
  P as HackleProvider,
  s as HackleStateSymbol,
  N as HackleVariation,
  C as createInstance,
  z as useFeatureFlag,
  g as useFeatureFlagDetail,
  q as useInstance,
  j as useVariation,
  h as useVariationDetail
};
